// Module
var code = "<section class=\"single-related page-detail-wrapper\"> <div class=\"page-detail\"> <span></span><span></span><span></span><span></span><span></span> </div> <div class=\"container-fluid\"> <h1 class=\"single-related-title\">Posts relacionados</h1> </div> <ul data-single-related-list class=\"single-related-list\"> </ul> </section>";
// Exports
export default code;